export default {
  // 标题
  tip: "提示",

  // 内容
  temporaryCanvasPrompt: "抱歉，当前为临时画布，请问是否需要保存该画布？",
  exitTemporaryCanvasPrompt:
    "当前为临时画布，退出之后该画布将不存在，如需保留请保存画布。请问是否需要退出？",

  // 按钮
  no: "否",
  yes: "是",
  exit: "退出",
  saveCanvas: "保存画布",
};
